/** A native inline disclosure; destinations and product eligibility stay in Liquid. */
class BannannaColorDisclosure extends HTMLElement {
  #controller;
  #observer;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const details = this.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;
    this.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) details.open = false;
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      summary.focus({ preventScroll: true });
    }, { signal });
    // A return from another color must start with the garment, not an old open list.
    window.addEventListener('pagehide', () => { details.open = false; }, { signal });
    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting && details.open && (!this.contains(document.activeElement) || document.activeElement === summary)) {
        details.open = false;
      }
    });
    this.#observer.observe(this);
  }
  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
  }
}
if (!customElements.get('bannanna-color-disclosure')) {
  customElements.define('bannanna-color-disclosure', BannannaColorDisclosure);
}
